import React from "react";
import {compose, withProps, lifecycle} from "recompose";
import ExploreNeighbourhoods from '../ExploreNeighbourhoods'
import googleMapsStylings from './googleMapStylings';
import {
  // getNeighbourhoodsColours,
  getIcons
} from "../../../../actions/Map/dataActions.js";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  // Marker,
  Polygon,
  // OverlayView,
  InfoWindow,
  DirectionsRenderer
} from "react-google-maps";
import styles from "./MapComponent.scss";
import {connect} from 'react-redux';
import {setNeighbourhood} from '../../../../actions/Map/navActions';

const MapComponent = compose(withProps({
  googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyAFvGxWf3FY3V3aIfKtnfz7VFN_3PU-ci8&v=3.exp&libraries=geometry,drawing,places",
  loadingElement: <div style={{
      height: `100%`
    }}/>,
  containerElement: <div style={{
      height: `100%`
    }}/>,
  mapElement: <div style={{
      height: `100%`
    }}/>,
  center: {
    lat: 44.320440,
    lng: -76.439077
  },
  zoom: 11,
  polygon: undefined
}), lifecycle({
  componentWillMount() {
  },
  componentDidMount(){
    // getIcons().then(res => {ICONS = res.data})
    this.setPolygon();
  },
  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(this.props.polygon_coordinates) !== JSON.stringify(nextProps.polygon_coordinates)) {

    }
  },
  componentDidUpdate(prevProps, prevState) {
    // if ((prevProps.house.lat !== this.props.house.lat) ||
    //   (prevProps.house.lng !== this.props.house.lng) ||
    //   (prevProps.work.lat !== this.props.work.lat) ||
    //   (prevProps.work.lng !== this.props.work.lng) ||
    //   (prevProps.travel_mode !== this.props.travel_mode)) {
    //   setTimeout(() => {
    //     if (this.props.house.lat && this.props.house.lng
    //     && this.props.work.lat && this.props.work.lng){
    //       this.setState({directions: undefined})
    //       const DirectionsService = new window.google.maps.DirectionsService();
    //       DirectionsService.route({
    //         origin: new window.google.maps.LatLng(this.props.house.lat, this.props.house.lng),
    //         destination: new window.google.maps.LatLng(this.props.work.lat, this.props.work.lng),
    //         travelMode: window.google.maps.TravelMode[this.props.travel_mode]
    //       }, (result, status) => {
    //         if (status === window.google.maps.DirectionsStatus.OK) {
    //           this.setState({directions: result});
    //         } else {
    //           console.error(`error fetching directions ${result}`);
    //         }
    //       });
    //     }
    //     else {
    //       this.setState({directions: undefined});
    //     }
    //
    //   }, 500);
    // }

    if (prevProps.colours !== this.props.colours
    || prevProps.polygon_coordinates !== this.props.polygon_coordinates){
      this.setPolygon();
    }
  },
  setPolygon(){
    if (this.props.polygon_coordinates !== undefined){
      this.setState({
        zoomToMarkers: map => {
          if (map && this.props.polygon_coordinates) {
            const extremities = this.props.getExtremities(this.props.polygon_coordinates);
            var bounds = new window.google.maps.LatLngBounds();
            bounds.extend(extremities.sw);
            bounds.extend(extremities.ne);
            // if (nextProps.work){ bounds.extend(nextProps.work) }
            map.fitBounds(bounds);
          }
        }
      });
      this.setState({polygonItem: []});
      var colour = this.props.colours[this.props.selected_neighbourhood]
      setTimeout(() => {
        if (this.props.polygon_coordinates.length >= 2) {
          for (let i = 0; i < this.props.polygon_coordinates.length; i++) {
            this.setState({
              polygonItem: ([
                ...this.state.polygonItem,
                <Polygon key={i} paths={this.props.polygon_coordinates[i]} options={{
                    fillColor: colour,
                    fillOpacity: 0.6,
                    strokeColor: colour,
                    strokeOpacity: 1,
                    strokeWeight: 1
                  }}/>
              ])
            });
          }
        } else if (this.props.polygon_coordinates.length === 1){
          this.setState({
            polygonItem: [(<Polygon
                key={0}
                paths={this.props.polygon_coordinates} options={{
                fillColor: colour,
                fillOpacity: 0.6,
                strokeColor: colour,
                strokeOpacity: 1,
                strokeWeight: 1
              }}/>)]
          });
        }
      }, 500);
    }
  }
}), withScriptjs, withGoogleMap)(props => (
  <GoogleMap
    zoom={props.zoom}
    center={props.search_box_result
      ? props.search_box_result
      : props.center
    }
    ref={props.zoomToMarkers}
    defaultOptions={{
      styles: googleMapsStylings,
      center: props.center,
      minZoom: 11,
      mapTypeControl: true,
      fullscreenControl: false,
      mapTypeControlOptions: {
        style: {},
        mapTypeIds: ['roadmap', 'satellite']
      }
    }}>

  {
    props.infoWindow && (
      <InfoWindow
      position={props.infoWindow.position}
      onCloseClick={() => props.closeInfoWindow()}
      // getPixelPositionOffset={100}
      >
      <div className={styles.InfoWindow}>
        <h4>{props.infoWindow.name}</h4>
        <div className={styles.InfoDiv}>
          {props.infoWindow.info}
        </div>
      </div>
    </InfoWindow>)
  }

  {props.markersArray}

  {/*
    props.house.lat && props.house.lng && (<Marker position={{
        lat: props.house.lat,
        lng: props.house.lng
      }} icon={{
        url: ICONS.house
      }}/>)
  }

  {
    props.work.lat && props.work.lng && (<Marker position={{
        lat: props.work.lat,
        lng: props.work.lng
      }} icon={{
        url: ICONS.work
      }}/>)
  */}

  {!props.selected_neighbourhood &&
    <ExploreNeighbourhoods
      setNeighbourhood={props.setNeighbourhood}
    />
  }

  {props.directions && (
      <DirectionsRenderer
        directions={props.directions}
        defaultOptions={{ suppressMarkers: true }}
      />)
  }

  {props.polygon_coordinates && props.polygonItem}
</GoogleMap>));

function mapStateToProps(state) {
  return {
    // house: state.survey.house,
    // work: state.survey.work,
    // travel_mode: state.nav.travel_mode,
    selected_neighbourhood: state.nav.selected_neighbourhood,
    colours: state.nav.colours,
    polygon_center: state.nav.polygon_center,
    search_box_result: state.nav.search_box_result
  };
}

const actions = {
  setNeighbourhood,
  getIcons,
  // getNeighbourhoodsColours
};

export default connect(mapStateToProps, actions)(MapComponent);



// WEBPACK FOOTER //
// ./src/components/pages/Map/MapComponent/MapComponent.js